<template>
  <div
    class="section"
    :class="[
      { bg: backgroundColor || backgroundClass },
      backgroundColor ? '' : backgroundClass,
    ]"
    :style="backgroundColor ? `backgroundColor: ${backgroundColor}` : ''"
  >
    <div class="content">
      <div v-for="(row, index) in section.rows" :key="index + '-' + refreshKey" class="content-item">
        <!-- <pre>{{ row.options }}</pre> -->
        <CarouselRow v-if="row.type === 'carousel'" :row="row" />
        <GridRow v-else-if="row.type === 'grid-xn'" :row="row" />
        <ContentGeneratorRow v-else :row="row" />
      </div>
    </div>
  </div>
</template>

<script>
import { contentFindOption } from '../../plugins/content'
import ContentGeneratorRow from './Row.vue'
import CarouselRow from './CarouselRow.vue'
import GridRow from './GridRow.vue'
export default {
  components: {
    ContentGeneratorRow,
    CarouselRow,
    GridRow
  },
  props: {
    section: { type: Object, default: null }
  },
  data () {
    return {
      refreshKey: 0
    }
  },
  computed: {
    backgroundColor () {
      return contentFindOption(this.section.options, 'backgroundColor').value || null
    },
    backgroundClass () {
      return contentFindOption(this.section.options, 'backgroundClass').value || null
    }
  },
  watch: {
    section: {
      handler () {
        this.refreshKey++
      },
      deep: true
    }
  }
}

</script>

<style lang="scss" scoped>
.section {
  width: 100%;
  max-width: 100%;
  position: relative;
  padding: 80px 0;

  @include mobile {
    padding: 48px 0;
  }

  &:first-child {
    padding-top: 32px;
  }

  &.bg {
    // max-width: 100vw;
    // width: 100vw !important;
    // margin-left: #{'calc((1002px - 100dvw) / 2)'};
    // @include touch{
    //   max-width: calc(100vw + 50px);
    //   margin: 0 -18px;
    //   // margin-left: -25px;
    //   }
    // .content{
    //   width: 1002px;
    //   margin: 0 auto;
    //   @include mobile{
    //     width: calc(100vw - 50px);
    //     // margin: 0 auto;
    //     padding: 0;
    //   }
    // }
    :deep(.row) + :deep(.row) {
      margin-top: 48px;

    }
  }
  // .content :deep(.row:first-child) {
  //   margin-top: 0;
  // }

  // .content:first-child {
  //   margin-top: 0;
  // }

.content > .content-item:last-child {
  div {
    margin-bottom: 0;
  }
}
  .content >.content-item:first-child {
   div {

     margin-top: 0;
   }

  }

  // .content :deep(.row:last-child) {
  //   margin-bottom: 0;
  // }
}
</style>
